// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__3s1vD","sendOtp":"AuthorizeToLogin_sendOtp__2ok2o"};